/* eslint-disable no-undef */
export const BASEURL = WebApiBaseUrl